export enum SwitchOnField {
  hasAnonymousCaller = 'hasAnonymousCaller',
  callListId = 'callListId',
}
